module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Bold.8a5b2818.ttf";